import { useState, useEffect } from "react";
import { AuthContext } from "./AuthContext";
import { loginApi, logoutApi } from "../api/auth.api";
import { isTokenExpired } from "../utils/jwt";
import { toast } from "react-toastify";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token =
      localStorage.getItem("ecoval_token") ||
      sessionStorage.getItem("ecoval_token");

    const storedUser =
      localStorage.getItem("ecoval_user") ||
      sessionStorage.getItem("ecoval_user");

    if (token && storedUser) {
      if (isTokenExpired(token)) {
        localStorage.removeItem("ecoval_token");
        localStorage.removeItem("ecoval_user");
        sessionStorage.removeItem("ecoval_token");
        sessionStorage.removeItem("ecoval_user");
        setUser(null);
      } else {
        setUser(JSON.parse(storedUser));
      }
    }

    setLoading(false);
  }, []);

  const login = async ({ email, password, rememberMe }) => {
    try{
	const data = await loginApi({ email, password });

        const storage = rememberMe ? localStorage : sessionStorage;

        storage.setItem("ecoval_token", data.token);
        storage.setItem("ecoval_user", JSON.stringify(data.user));

        setUser(data.user);
        toast.success("Login successful");
       } catch (error) {
	toast.error(error.response?.data?.message || "Invalid email or password");

        throw error;
    } 
  };

  const logout = async () => {
    try {
      await logoutApi();
    } catch (err) {
      console.warn("Logout API failed", err);
    }

    localStorage.removeItem("ecoval_token");
    localStorage.removeItem("ecoval_user");
    sessionStorage.removeItem("ecoval_token");
    sessionStorage.removeItem("ecoval_user");
    setUser(null);
    toast.success("Logged out");
  };

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
